import * as React from 'react';

type OnceCallback = (errorCode?: number) => Promise<void> | void;

export function useOnceCallbacks(params: {
	onForbidden?: OnceCallback;
	onError?: OnceCallback;
	resetKey?: string | number | null;
}) {
	const {onForbidden, onError, resetKey} = params;

	const forbiddenOnceRef = React.useRef(false);
	const errorOnceRef = React.useRef(false);

	React.useEffect(() => {
		forbiddenOnceRef.current = false;
		errorOnceRef.current = false;
	}, [resetKey]);

	const onForbiddenOnce = React.useCallback<OnceCallback>(
		async (code?: number) => {
			if (!onForbidden) return;
			if (forbiddenOnceRef.current) return;
			forbiddenOnceRef.current = true;
			await onForbidden(code);
		},
		[onForbidden],
	);

	const onErrorOnce = React.useCallback<OnceCallback>(
		async (code?: number) => {
			if (!onError) return;
			if (errorOnceRef.current) return;
			errorOnceRef.current = true;
			await onError(code);
		},
		[onError],
	);

	return {onForbiddenOnce, onErrorOnce};
}
